function index() {
  return (
    <div className="absolute top-0 z-50 flex  h-full w-full animate-pulse items-center  justify-center  bg-neutrals-200/50 delay-300">
      <div className="relative flex h-full w-full items-center justify-center">
        <div className="absolute   animate-spin">
          <svg fill="none" height="119" viewBox="0 0 119 119" width="119" xmlns="http://www.w3.org/2000/svg">
            <path
              className="fill-secondary-400"
              d="M5.95 59.5C2.66391 59.5 -0.0308354 62.1706 0.297206 65.4402C1.34582 75.8918 5.14785 85.9181 11.3635 94.4732C18.7491 104.639 29.1633 112.205 41.1135 116.088C53.0637 119.971 65.9363 119.971 77.8865 116.088C89.8367 112.205 100.251 104.639 107.637 94.4732C115.022 84.3078 119 72.0652 119 59.5C119 46.9348 115.022 34.6922 107.636 24.5268C100.251 14.3613 89.8367 6.79498 77.8865 2.91213C67.8294 -0.355617 57.1189 -0.873278 46.8548 1.35917C43.6438 2.05756 41.9367 5.44566 42.9521 8.57092C43.9676 11.6962 47.3223 13.3669 50.5498 12.749C58.4035 11.2454 66.5436 11.739 74.2092 14.2297C83.7693 17.336 92.1007 23.3891 98.0092 31.5214C103.918 39.6538 107.1 49.4479 107.1 59.5C107.1 69.5521 103.918 79.3462 98.0092 87.4786C92.1007 95.6109 83.7694 101.664 74.2092 104.77C64.6491 107.877 54.3509 107.877 44.7908 104.77C35.2307 101.664 26.8993 95.6109 20.9908 87.4786C16.2532 80.9578 13.2683 73.3686 12.2714 65.4347C11.8617 62.1743 9.23609 59.5 5.95 59.5Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default index;
